import { useUpdateCartLine } from './useCart';
import { useToast } from './useToast';

/**
 * Saves a cart line's note (PATCH /carts/active/items/{lineId} with `notes`).
 * `saveNote` resolves true on success; failures surface as a toast.
 */
export function useCartLineNote() {
  const updateCartLine = useUpdateCartLine();
  const toast = useToast();

  const saveNote = async (line, notes) => {
    try {
      await updateCartLine.mutateAsync({ lineId: line.lineId, quantity: line.quantity, notes });
      return true;
    } catch (err) {
      toast.apiError(err);
      return false;
    }
  };

  const isSavingNote = (line) =>
    updateCartLine.isPending && updateCartLine.variables?.lineId === line.lineId;

  return { saveNote, isSavingNote };
}
